module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-3-044f837959b96c1045e9f32218fbc83be34ecb4c60d3065e394143beb26b7efd.svg";